<template>
	<div class="invite-code-container">
		<FormItem :label="$t('groupsettings_invite_title')">
			<Input
				:large="large"
				v-model="value"
				autoFocus
				:placeholder="$t('groupinvites_paste_link_code')"
			/>
		</FormItem>
		<FormItem class="example" :label="$t('groupinvites_examples_label')">
			<pre v-text="$t('groupinvites_examples_text')" />
		</FormItem>
	</div>
</template>

<script>
import { FormItem, Input } from '@/components/common'
import { getInviteCodeFromUrl } from './index'

export default {
	name: 'InviteCodeForm',
	components: { FormItem, Input },
	props: { modelValue: null, large: { type: Boolean, default: null } },
	data() {
		return {
			value: null,
		}
	},
	emits: ['update:modelValue', 'change'],
	watch: {
		modelValue(val) {
			this.value = val
		},
		value(val) {
			// check to see if user has entered a url
			const code = getInviteCodeFromUrl(val)
			this.$emit('change', code || val)
			this.$emit('update:modelValue', code || val)
		},
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.example {
	color: $neutral-500;

	pre {
		margin: 0;
		font-size: 14px;
	}
}
</style>
